// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__FGPy2","label":"LabeledBox_label__u01gc"};